import { Faq } from "../components/Faq/Faq";
export const Support = () => {
  return <Faq/>;
};
